import React from "react";
import userInfoStore from "@/store/user.store";
import { IDisplayUserInfo } from "@/types/user";
import Avatar from "@/component/Avatar";

interface IProps {
  userInfo: IDisplayUserInfo;
  className?: string;
}
const UserAvatar: React.FC<IProps> = (props) => {
  const userId = userInfoStore((state) => state.userId);
  // 个人账号使用displayName，企业账号使用公司名
  props.userInfo.displayName = props.userInfo.identityType === 0 ? props.userInfo.displayName : props.userInfo.companyRealName ?? "";
  return <Avatar {...props} userInfo={{ ...props.userInfo, userId }} />
};

export default UserAvatar;
